<template>
    <div>
        <header style="background:#055fe6;margin-top:-45px;margin-bottom:15px;padding:15px;color:#FFF;">
            <div class="container-fluid">

                <div class="row">
                    <div class="col-lg-4 col-md-4" style="padding-top:18px;">
                        <p style="font-weight:600;margin-bottom:0px;">Pedidos de AETs</p>
                    </div>
                    <div class="col-lg-2 col-md-2">

                    </div>
                     <div class="col-lg-2 col-md-2">
                        <label style="color:#FFF;">Usuário</label>
                        <v-select v-model="usuario" label="nome" :options="usuarios" style="background:#FFF;border-radius:4px;"></v-select>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <label style="color:#FFF;">Tipo</label>
                        <v-select v-model="tipo" :options="['CVC','IND']" style="background:#FFF;border-radius:4px;"></v-select>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <label style="color:#FFF;">Empresa</label>
                        <v-select v-model="empresa" label="nome" :options="options" style="background:#FFF;border-radius:4px;"></v-select>
                    </div>
                </div>

            </div>
        </header>

        <div style="padding:25px;padding-top:0px;height:100%;">

            <div class="container-fluid" style="height:100%;">
                <div class="row" style="height:100%;">
                    <div class="col-lg-2 col-md-2" style="height:100%;">
                        <div style="height:100%;">
                            <div style="padding:10px;font-weight:bold;font-size:9pt;color:#666;">
                                ORÇAMENTOS
                            </div>

                            <draggable class="list-group" :list="orcamentos" group="pedidos" @change="log($event,0)">
                            
                                <pedido          
                                class="list-group-item"
                                v-for="element in orcamentos"
                                v-bind:key="element.id" 
                                :data="element">
                                </pedido>

                            </draggable>

                        

                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2" style="height:100%;">
                        <div style="height:100%;">
                            <div style="padding:10px;font-weight:bold;font-size:9pt;color:#666;">
                                PEDIDOS CONFIRMADOS
                            </div>

                            <draggable class="list-group" :list="pedidos" group="pedidos" @change="log($event,1)">
                            
                                <pedido          
                                class="list-group-item"
                                v-for="element in pedidos"
                                v-bind:key="element.id" 
                                :data="element">
                                </pedido>

                            </draggable>

                        

                        </div>
                    </div>
                    <div class="col-lg-2 col-md-2">
                        <div style="padding:10px;font-weight:bold;font-size:9pt;color:#666;">
                            FAZENDO
                        </div>

                        <draggable class="list-group" :list="fazendo" group="pedidos" @change="log($event,2)">
                                
                                <pedido          
                                class="list-group-item"
                                v-for="element in fazendo"
                                v-bind:key="element.id" 
                                :data="element">
                                </pedido>

                        </draggable>

                    </div>

                    <div class="col-lg-2 col-md-2">
                        <div style="padding:10px;font-weight:bold;font-size:9pt;color:#666;">
                            AGUARDANDO PAGAMENTO
                        </div>

                        <draggable class="list-group" :list="taxas" group="pedidos" @change="log($event,3)">
                                
                                <pedido          
                                class="list-group-item"
                                v-for="element in taxas"
                                v-bind:key="element.id" 
                                :data="element">
                                </pedido>

                        </draggable>

                    </div>

                    <div class="col-lg-2 col-md-2">
                        <div style="padding:10px;font-weight:bold;font-size:9pt;color:#666;">
                            LIBERADA
                        </div>

                        <draggable class="list-group" :list="liberada" group="pedidos" @change="log($event,4)">
                                
                                <pedido          
                                class="list-group-item"
                                v-for="element in liberada"
                                v-bind:key="element.id" 
                                :data="element">
                                </pedido>

                        </draggable>

                    </div>


                    <div class="col-lg-2 col-md-2">
                        <div style="padding:10px;font-weight:bold;font-size:9pt;color:#666;">
                            FATURAMENTO
                        </div>
                        <draggable class="list-group" :list="faturamento" group="pedidos" @change="log($event,5)">
                                
                                <pedido          
                                class="list-group-item"
                                v-for="element in faturamento"
                                v-bind:key="element.id" 
                                :data="element">
                                </pedido>

                        </draggable>
                    </div>

                </div>
            </div>

        </div>



    <nav class="navbar fixed-bottom navbar-expand-sm navbar-light">
        <div class="collapse navbar-collapse flex-grow-1 text-right" id="myNavbar7">
            <ul class="navbar-nav ml-auto flex-nowrap">
                <li class="nav-item">
                    <router-link to="/pedidos/novo" class="btn btn-primary">Novo pedido</router-link>
                </li>
            </ul>
        </div>
    </nav>

    </div>
</template>

<script>

import "vue-select/src/scss/vue-select.scss"
import draggable from 'vuedraggable'
import pedido from './opedido'
import config from '@/config'
import JQuery from 'jquery'
let $ = JQuery

export default {
    name:"Pedidos",
    components:{
        draggable, pedido
    },
    data(){
        return{
            num:1,
            lista:[],
            item:{
                orgaos:[],
                conjunto:{},
                carga:{}
            },
            pedido:{},
            config:config,
            orcamentos:[],
            pedidos: [],
            fazendo: [],
            taxas: [],
            liberada: [],
            faturamento:[],
            options: [],
            usuarios:[
                {id:1,nome:'Samuel Rocha'},
                {id:2,nome:'Vanderlei Bomfim'}
            ],
            usuario:{id:1,nome:'Samuel Rocha'},
            empresa:{id:0,nome:'TODAS'},
            tipo:'CVC',
            orgaos:{}
        }
    },
    methods: {
        ListarOrgaos(){
            this.$http.get(this.config.API+'orgaos')
            .then((response) => {
                console.log(response)
                this.orgaos = response.data.data;
            });
        },
        add: function() {
            console.log('ADD')
        },
        replace: function() {
            console.log('REPLACE')
        },
        clone: function(el) {
            return {
                name: el.name + " cloned"
            };
        },
        log: function(evt, lista) {
            if(evt.added){
                let id = evt.added.element.id
                window.console.log(evt.added.element.id,lista);
                this.$http.put(this.config.API+'pedidos/etapa/'+lista+'/'+id).then(res => {
                    console.log(res)
                })
            }
        },
        SalvarItem(){
            console.log(this.item)
            this.item.id = this.num;
            this.lista.push(this.item)
            this.num++;
            this.item = {
                orgaos:[],
                conjunto:{},
                carga:{}
            }
            $('#item-pedido').modal('hide')
        },
        EditarItem(item){
            console.log(item)
            this.item = item;
        },

        ListarPedidos(type){
            return this.$http.get(this.config.API+'pedidos/'+type)
        }
  },
  beforeMount(){
      this.ListarOrgaos();

      // listar orçamentos
      this.ListarPedidos(0).then(response => {
          this.orcamentos = response.data.data
      })

      // listar pedidos confirmados
      this.ListarPedidos(1).then(response => {
          this.pedidos = response.data.data
      })

      // listar fazendo
      this.ListarPedidos(2).then(response => {
          this.fazendo = response.data.data
      })

      // listar aguardando pagamento
      this.ListarPedidos(3).then(response => {
          this.taxas = response.data.data
      })

      // listar liberadas
      this.ListarPedidos(4).then(response => {
          this.liberada = response.data.data
      })

      // listar faturamento
      this.ListarPedidos(5).then(response => {
          this.faturamento = response.data.data
      })



  }
}
</script>